import { findIndex } from 'lodash';
import { connect } from 'react-redux';

import Tabs from 'components/Tabs';
import { getCurrentProduct } from 'state/selectors/pdp';

import { TEST_PDPS } from './constants';

const mapStateToProps = state => {
  const product = getCurrentProduct(state);
  const handle = product.master;

  const tabs = TEST_PDPS[handle] || [];

  const tagNames = tabs.map(({ text }) => text);
  const tagUrls = tabs.map(({ href }) => href);

  const activeIndex = findIndex(tabs, ['handle', handle]);

  return {
    tabs: tagNames,
    linkUrls: tagUrls,
    activeTabIndex: activeIndex,
    enableScrollTo: false,
    fullWidthUnderLine: true,
  };
};

export default connect(mapStateToProps)(Tabs);
